/**
 * Componente de mensagem de erro
 */

import { FiXCircle } from "react-icons/fi";

interface ErrorMessageProps {
  error: string | null;
}

export function ErrorMessage({ error }: ErrorMessageProps) {
  if (!error) return null;

  return (
    <div
      className="mb-6 rounded-2xl border border-rose-200 bg-rose-50 p-4 text-rose-800 shadow-sm"
      role="alert"
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex text-lg">
          <FiXCircle aria-hidden="true" />
        </span>
        <span className="text-sm font-semibold leading-6">{error}</span>
      </div>
    </div>
  );
}
